import { Grid } from '@mui/material';

import {
  FormAutocompleteField,
  FormDateField,
  FormRichTextField,
  FormTextField,
} from '../../../../../common';
import {
  MEDICAL_HEARING_OPTIONS,
  MEDICAL_HISTORY_MAX_LENGTH,
  MEDICAL_VISION_OPTIONS,
} from '../constants';

import type { MedicalFieldsProps } from '../types';

export default function MedicalHistoryFields({
  formik,
  disabled,
  readOnly,
  saveField,
}: MedicalFieldsProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Allergies"
          name="allergies"
          onBlur={saveField}
          placeholder='Enter allergies (if not applicable, please write “none”)'
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Special diets"
          name="special_diets"
          onBlur={saveField}
          placeholder='Enter diets (if not applicable, please write “none”)'
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Hearing difficulties"
          name="hearing_difficulty"
          onChange={saveField}
          options={MEDICAL_HEARING_OPTIONS.map((value) => ({ label: value, value }))}
          placeholder="Enter hearing difficulties"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormDateField
          disabled={disabled}
          formik={formik}
          format="MM-YYYY"
          label="Hearing screening date"
          name="hearing_screening_date"
          onChange={saveField}
          picker="month"
          placeholder="Select date"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Vision difficulties"
          name="vision_difficulty"
          onChange={saveField}
          options={MEDICAL_VISION_OPTIONS.map((value) => ({ label: value, value }))}
          placeholder="Enter vision difficulties"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormDateField
          disabled={disabled}
          formik={formik}
          format="MM-YYYY"
          label="Vision screening date"
          name="vision_screening_date"
          onChange={saveField}
          picker="month"
          placeholder="Select date"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormRichTextField
          disabled={disabled}
          formik={formik}
          label="Trauma history"
          maxLength={MEDICAL_HISTORY_MAX_LENGTH}
          minHeight={120}
          name="trauma_history"
          onBlur={saveField}
          placeholder='Enter trauma history. Enter “None” if no trauma history.'
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormRichTextField
          disabled={disabled}
          formik={formik}
          label="Surgical or hospitalization history"
          maxLength={MEDICAL_HISTORY_MAX_LENGTH}
          minHeight={120}
          name="hospitalization_history"
          onBlur={saveField}
          placeholder='Enter surgical and/or hospitalization history. Enter “None” if no surgical or hospitalization history.'
          readOnly={readOnly}
          required
        />
      </Grid>
    </Grid>
  );
}
